import MapView from 'react-native-maps';
export default MapView;
